import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
const Ctx = createContext(null);
function resolveSystem() {
    if (typeof window === "undefined" || !window.matchMedia)
        return "dark";
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
const STORAGE_KEY = "atlas:theme-mode";
export function ThemeProvider({ children, defaultMode = "system" }) {
    const [mode, setMode] = useState(() => {
        if (typeof window === "undefined")
            return defaultMode;
        return window.localStorage.getItem(STORAGE_KEY) ?? defaultMode;
    });
    const [resolved, setResolved] = useState(mode === "system" ? resolveSystem() : mode);
    useEffect(() => {
        const apply = () => setResolved(mode === "system" ? resolveSystem() : mode);
        apply();
        if (mode === "system" && typeof window !== "undefined") {
            const mq = window.matchMedia("(prefers-color-scheme: dark)");
            mq.addEventListener("change", apply);
            return () => mq.removeEventListener("change", apply);
        }
        return undefined;
    }, [mode]);
    useEffect(() => {
        if (typeof document !== "undefined")
            document.documentElement.setAttribute("data-theme", resolved);
    }, [resolved]);
    useEffect(() => {
        if (typeof window !== "undefined")
            window.localStorage.setItem(STORAGE_KEY, mode);
    }, [mode]);
    return _jsx(Ctx.Provider, { value: { mode, resolved, setMode }, children: children });
}
export function useThemeMode() {
    const v = useContext(Ctx);
    if (!v)
        throw new Error("useThemeMode must be inside <ThemeProvider>");
    return v;
}
//# sourceMappingURL=ThemeProvider.js.map